import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="param-autoclick"
export default class extends Controller {
  static values = { name: String }

  connect() {
    if (this.#shouldClick()) this.element.click()
  }

  #shouldClick() {
    const uri = new URL(window.location)
    return uri.searchParams.get(this.nameValue) === 'true'
  }
}
